import { css } from '@emotion/css'
import { accessiblyHidden, spacing } from '@offerzen/pinata-shame'

const styles = {
  accessiblyHidden: css(accessiblyHidden),

  card: css({
    width: '100%',
    padding: spacing.medium,
  }),

  content: css({
    marginLeft: spacing.default,
    display: 'flex',
    flexDirection: 'column',

    '& > *': {
      marginTop: spacing.small,
    },
  }),
}

export default styles
